import csTools from "cornerstone-tools";
import { ERASE_COLOR, ERASE_BASE_COLOR } from "./colors-for-brush";
const external = csTools.external;

import getTinyBrushMixin from "./get-tiny-brush-mixin";

/**
 * Called by the event dispatcher to render the image.
 *
 * @param {Object} evt - The event.
 * @returns {void}
 */
function renderBrush(evt) {
  const eventData = evt.detail;
  const elementId = eventData.element.id;

  const selectedViewerId =
    window.angular?.stateManagerProjectService?.getSelectedViewerId() ??
    elementId;

  if (selectedViewerId !== elementId) {
    return;
  }

  const { cornerstone } = external;
  const viewport = eventData.viewport;

  let mousePosition;

  if (this._drawing) {
    mousePosition = this._lastImageCoords;
  } else if (this._mouseUpRender) {
    mousePosition = this._lastImageCoords;
    this._mouseUpRender = false;
  } else {
    mousePosition = csTools.store.state.mousePositionImage;
  }

  if (!mousePosition) {
    return;
  }

  const { rows, columns } = eventData.image;
  const { x, y } = mousePosition;

  if (x < 0 || x > columns || y < 0 || y > rows) {
    return;
  }

  // Draw the hover overlay on top of the pixel data
  const radius = csTools.getModule("segmentation").configuration.radius;
  const context = eventData.canvasContext;
  const element = eventData.element;
  const color = ERASE_BASE_COLOR;

  context.setTransform(1, 0, 0, 1, 0, 0);

  const widthOfSquare = 2 * radius * viewport.scale;
  const mouseCoordsCanvas = cornerstone.pixelToCanvas(element, mousePosition);
  const xCoords = mouseCoordsCanvas.x - radius * viewport.scale;
  const yCoords = mouseCoordsCanvas.y - radius * viewport.scale;

  context.beginPath();

  context.lineWidth = 1;
  context.strokeStyle = color;
  if (radius == 1) {
    const widthOfRect =
      rows < columns || rows == columns
        ? widthOfSquare
        : widthOfSquare * (eventData.image.columnPixelSpacing / eventData.image.rowPixelSpacing);
    const heightOfRect =
      rows > columns || rows == columns
        ? widthOfSquare
        : widthOfSquare * (eventData.image.rowPixelSpacing / eventData.image.columnPixelSpacing);
    getTinyBrushMixin(context, widthOfRect / 2, heightOfRect / 2, mouseCoordsCanvas.x, mouseCoordsCanvas.y, ERASE_COLOR);
  } else {
    context.rect(xCoords, yCoords, widthOfSquare, widthOfSquare);
    context.stroke();

    context.beginPath();

    const widthOfSecondSquare = widthOfSquare * 0.2 < 3 ? widthOfSquare * 0.2 : 3;

    context.lineWidth = widthOfSecondSquare;
    context.strokeStyle = `rgba(${ERASE_COLOR.join()}, 1)`;
    context.rect(
      xCoords + widthOfSecondSquare / 2,
      yCoords + widthOfSecondSquare / 2,
      widthOfSquare - widthOfSecondSquare,
      widthOfSquare - widthOfSecondSquare
    );
    context.stroke();

    context.beginPath();

    context.rect(
      xCoords + widthOfSecondSquare / 2,
      yCoords + widthOfSecondSquare / 2,
      widthOfSquare - widthOfSecondSquare,
      widthOfSquare - widthOfSecondSquare
    );
    context.fillStyle = `rgba(${ERASE_COLOR.join()}, 0.25)`;
  }
  context.fill();
}

/**
 * @mixin polygonSegmentationMixin - segmentation operations for polyline
 * @memberof Mixins
 */
export default {
  renderBrush,
};
